import api from '@/lib/api';
import { toast } from 'sonner';

export async function createShareCard(toolType, resultData) {
  try {
    const res = await api.post('/tools/share-card', {
      tool_type: toolType,
      result_data: resultData,
    });
    return res.data;
  } catch {
    toast.error('Failed to create share link');
    return null;
  }
}

export function copyShareLink(shareUrl) {
  const fullUrl = `${window.location.origin}${shareUrl}`;
  navigator.clipboard.writeText(fullUrl).then(() => {
    toast.success('Share link copied to clipboard!');
  }).catch(() => {
    toast.error('Failed to copy');
  });
}
